<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1200px"
      :show-save-button="$permission.canEdit()"
      unit="内容"
      edit-title
      id-key="RecordId"
      :data="data"
      form-label-width="105px"
      :form-rules="rules"
      :save-func="api.save"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      close-on-saved
      :before-save="onBeforeSave"
      @closed="onClosed"
      @close-saved="$emit('close-saved')"
    >
      <!--width是整个窗口的宽度-->
      <template slot="form">
        <el-row>
          <el-col :span="24">
            <!--这句用于判断手机和电脑的不同显示，如果是手机则24表示全屏，如果是电脑，则12表示占一半-->
            <el-form-item label="内容标题" prop="NotesTitle">
              <el-input
                v-model="data.NotesTitle"
                placeholder="请填写内容标题"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="isMB ? 24 : 12"> </el-col>
        </el-row>
        <el-row v-if="data.RecordId == 5">
          <el-col :span="12">
            <el-form-item label="图片" prop="NotesPhoto">
              <span style="color: #909399">封面图，只允许上传一张</span>
              <single-upload
                :upload-url="uploadPicUrl"
                v-model="data.NotesPhoto"
                @input="inputText"
              />
              <span style="color: red">最佳宽高比例9：4</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="data.RecordId == 5">
          <el-col :span="24">
            <el-form-item label="视频">
              <upload-video
                v-model="data.NotesVideo"
                :upload-url="uploadVideoUrl"
                :file-size="videoSize"
              ></upload-video>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <!--多行文本框，无论手机和电脑都占满，所有都是24-->
            <!--   <el-form-item label="条款内容" prop="TermContent">
                <el-input v-model="data.TermContent" type="textarea" rows="12" placeholder="请填写条款内容" clearable></el-input>
            默认普通文本编辑框不用加type，type="textarea"为多行文本框
            </el-form-item>-->
            <el-form-item
              :label="isMB ? '' : '内容明细'"
              :label-width="isMB ? '0' : ''"
              prop="NotesDetail"
            >
              <el-divider v-if="isMB">内容明细</el-divider>
              <editor
                ref="editor"
                v-model="data.NotesDetail"
                height="400px"
              ></editor>
              <el-input v-model="data.NotesDetail" v-show="false"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="isMB ? 24 : 12"> </el-col>
        </el-row>
      </template>
      <template #footer v-if="!$permission.canEdit()">
        <el-button @click="close">关 闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
  <script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import singleUpload from "@/components/common/photo/singleUpload";
import uploadVideo from "@/components/common/files/uploadVideo";
import editor from "@/components/common/editor.vue";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    singleUpload,
    uploadVideo,
    editor,
  },
  data() {
    return {
      data: {
        //每次刷新页面后各编辑框的初始值，例如某个字段如果不清空，继承上一次编辑的内容，则不赋予初值就好
        RecordId: 0,
        NotesTitle: "",
        NotesDetail: "",
        NotesPhoto: "",
        NotesVideo: "",
      },
      api: require("@/api/sy/singlenotes").default,
      isMB: this.$store.state.isMB,
      rules: {
        NotesTitle: [{ required: true, message: "内容标题不能为空" }], //TermName这个名称就必须和上面各类录入框的prop属性值一致，就是控制同名的录入框的必填
        NotesDetail: [{ required: true, message: "内容明细不能为空" }],
      },
      uploadPicUrl: "/api/Common/UploadPicture",
      uploadVideoUrl: "/api/Common/UploadMP4",
    };
  },
  computed: {
    host() {
      return window.location.origin;
    },
    videoSize() {
      return this.$store.state.user.videoSize;
    },
  },
  methods: {
    inputText(val) {
      this.data.NotesPhoto = val;
      this.$refs.dialog.$refs.form.validate();
    },
    onCreateOpened(row) {},
    onEditOpened(row) {},
    onBeforeSave() {},
    onClosed() {},
  },
};
</script>